import React from 'react'
import { toAbsoluteUrl } from "../../Utils/_helpers";

export const Alert = (props) => {
  return (
    <>
      {props.msg && (
        <div
          className="ticker-error-alert"
          style={props.style ? props.style : { width: "95%" }}
        >
          <div>
            <span>
              <img
                alt=""
                className="exclamation-icon"
                src={toAbsoluteUrl("/media/sr/icons/error-exclamation.svg")}
              />
            </span>
            <span>{props.msg}</span>
          </div>
          {!props.clearDisabled && (
            <div>
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  props.onClose();
                }}
              >
                <img
                  alt=""
                  className="click-icon"
                  src={toAbsoluteUrl("/media/sr/icons/alert-close.svg")}
                />
              </a>
            </div>
          )}
        </div>
      )}
    </>
  );
};
